import { InjectionToken } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';
import { CoreConfig } from './core.config';

export const CORE_CONFIG = new InjectionToken<CoreConfig>('CoreConfig');
export interface ErrorSimulationConfig {
  enabled: boolean;
}

export const ERROR_SIMULATION_CONFIG = new InjectionToken<ErrorSimulationConfig>('ErrorSimulationConfig');

/** Frontend-only name of the action associated with an HTTP request. */
export const ERROR_ACTION_KEY = new HttpContextToken<string | null>(() => null);
